import React from 'react';
import dayjs from 'dayjs';

const PoshanServiceDetails = ({ data }: { data: any }) => {

        const hasOtherDetails =
    data.height || 
    (!isNaN(data.height_in_cm) && data.height_in_cm) || 
    data.weight || 
    (!isNaN(data.weight_in_kg) && data.weight_in_kg) || 
    data.last_growth_monitoring_date;

    return (
        <div className="poshan-service-details">
            <div className="poshan-services-header">{'THR Details'}</div>
            <div className="poshan-service-details-wrapper">
                {(data.THR || data.thr) && (
                    <div className="poshan-service-detail-item">
                        <div className="poshan-service-detail-key">THR</div>
                        <div className="poshan-service-detail-value">{data.THR ?? data.thr ?? '-'}</div>
                    </div>
                )}
                {(
                    <div className="poshan-service-detail-item">
                        <div className="poshan-service-detail-key">THR No. of Day</div>
                        <div className="poshan-service-detail-value">{data.THR_no_of_day ?? data.thr_no_of_day ?? '-'}</div>
                    </div>
                )}
                {data.last_thr_given_date && (
                    <div className="poshan-service-detail-item">
                        <div className="poshan-service-detail-key">Last THR Given Date</div>
                        <div className="poshan-service-detail-value">
                            {dayjs(data.last_thr_given_date).format('DD-MM-YYYY') ?? '-'}
                        </div>
                    </div>
                )}
            </div>
            <div className="poshan-services-header">{'HCM Details'}</div>
            <div className="poshan-service-details-wrapper">
                {(data.HCM || data.hcm) && (
                    <div className="poshan-service-detail-item">
                        <div className="poshan-service-detail-key">HCM</div>
                        <div className="poshan-service-detail-value">{data.HCM ?? data.hcm ?? '-'}</div>
                    </div>
                )}
                {data.last_hcm_given_date && (
                    <div className="poshan-service-detail-item">
                        <div className="poshan-service-detail-key">Last HCM Given Date</div>
                        <div className="poshan-service-detail-value">
                            {dayjs(data.last_hcm_given_date).format('DD-MM-YYYY') ?? '-'}
                        </div>
                    </div>
                )}
            </div>
            {hasOtherDetails && (
                <>
                    <div className="poshan-services-header">{'Other Details'}</div>
                    <div className="poshan-service-details-wrapper">
                        {(data.height || data.height_in_cm || data.height_in_cm !== 'NaN' || data.height !== 'NaN') && (
                            <div className="poshan-service-detail-item">
                                <div className="poshan-service-detail-key">Height in cm</div>
                                <div className="poshan-service-detail-value">{data.height ?? data.height_in_cm ?? '-'}</div>
                            </div>
                        )}
                        {(data.weight || data.weight_in_kg) && (
                            <div className="poshan-service-detail-item">
                                <div className="poshan-service-detail-key">Weight in Kg</div>
                                <div className="poshan-service-detail-value">{data.weight ?? data.weight_in_kg ?? '-'}</div>
                            </div>
                        )}
                        {data.last_growth_monitoring_date && (
                            <div className="poshan-service-detail-item">
                                <div className="poshan-service-detail-key">Last Growth Monitoring Date</div>
                                <div className="poshan-service-detail-value">
                                    {dayjs(data.last_growth_monitoring_date).format('DD-MM-YYYY') ?? '-'}
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default PoshanServiceDetails;